const options = {
  5: "bg-red-900/5",
  10: "bg-red-900/10",
  25: "bg-red-900/25",
  50: "bg-red-900/50",
  75: "bg-red-900/75",
  90: "bg-red-900/90",
  100: "bg-red-900",
};

const from = {
  5: "from-red-900/5",
  10: "from-red-900/10",
  25: "from-red-900/25",
  50: "from-red-900/50",
  75: "from-red-900/75",
  90: "from-red-900/90",
  100: "from-red-900",
};

export default function getBackgroundRed900(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
